// File: ForgettingPassword.jsx
// Place this file in your React project (e.g. src/components/ForgettingPassword.jsx)

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ForgettingPassword.css";
import BASE_URL from "../BaseUrl";
import axios from "axios";
 
export default function ForgettingPassword() {
  const [step, setStep] = useState(1); // 1=email, 2=otp, 3=new-password
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  // helper to read backend response (try json then text)

  const showServerMessage = (text) => {
    setMessage(text);
    setShowMessage(true);
  };

  const sendEmail = async () => {
    if (!email) return showServerMessage("الرجاء إدخال البريد الإلكتروني");
    setLoading(true);
    console.log(email);
    try {
      const response = await axios.post(`${BASE_URL}/auth/forgot-password`,email,{
        headers:{
          "Content-Type":"text/plain"
        }
      });

      showServerMessage(response.data);
      setStep(2);
    } catch (err) {
      console.log(err);
      if(err.status === 403)
      showServerMessage(err.response.data);
    } finally {
      setLoading(false);
    }
  };

  const sendOTP = async () => {
    if (!otp) return showServerMessage("الرجاء إدخال رمز التحقق (OTP)");
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/auth/forgetting-password-otp`, JSON.stringify({ email, otp }),{
        withCredentials:true,
        headers: { "Content-Type": "application/json" },
       
      });
      showServerMessage(response.data);
      if(response.status === 200){
        setStep(3);
        setOtp("");
      }
    } catch (err) {
      if(err.response.status === 406 || err.response.status === 404){
        showServerMessage(err.response.data);
      }
      else{
        showServerMessage("خطأ في الاتصال بالخادم");
      }
    } finally {
      setLoading(false);
    }
  };

  const sendNewPassword = async () => {
    if (!newPassword || !confirmPassword)
      return showServerMessage("الرجاء إدخال كلمة المرور وتأكيدها");
    if (newPassword !== confirmPassword)
      return showServerMessage("كلمتا المرور غير متطابقتين");

    setLoading(true);
    try {
      const data = {email,newPassword};
      const response = await axios.post(`${BASE_URL}/auth/reset-password`,data, {
        headers: { "Content-Type": "application/json" },
        withCredentials:true,
      });
      showServerMessage(response.data);

      if (response.status=== 200) {
        // success - optionally reset component or redirect
        showServerMessage(response.data);
        setTimeout(()=>{navigate("/");},3000);
      }
    } catch (err) {
      if(err.response.status === 404 || err.response.status === 401){
        showServerMessage(err.response.data);
      }else{
        showServerMessage("خطأ في الاتصال بالخادم");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fp-container">
      <h2 className="fp-title">إعادة تعيين كلمة المرور</h2>

      {step === 1 && (
        <div className="fp-form">
          <label>البريد الإلكتروني</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="example@domain.com"
          />
          <button onClick={sendEmail} disabled={loading} className="fp-btn">
            {loading ? "جارٍ..." : "إرسال رمز إلى البريد"}
          </button>
        </div>
      )}

      {step === 2 && (
        <div className="fp-form">
          <p className="fp-note">لقد أرسلنا رمز التحقق إلى البريد: <b>{email}</b></p>
          <label>رمز التحقق (OTP)</label>
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="ادخل رمز التحقق"
          />
          <div className="fp-row">
            <button onClick={sendOTP} disabled={loading} className="fp-btn">
              {loading ? "جارٍ..." : "تحقق"}
            </button>
            <button
              onClick={() => {setStep(1);setOtp("");}}
              className="fp-btn fp-secondary"
              disabled={loading}
            >
              عدّ إلى البريد
            </button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="fp-form">
          <label>كلمة المرور الجديدة</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="أدخل كلمة المرور الجديدة"
          />

          <label>تأكيد كلمة المرور</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="أعد إدخال كلمة المرور"
          />

          <div className="fp-row">
            <button
              onClick={sendNewPassword}
              disabled={loading}
              className="fp-btn"
            >
              {loading ? "جارٍ..." : "حفظ"}
            </button>
            <button
              onClick={() => {
                setConfirmPassword("");
                setNewPassword("");
                setOtp("");
                setStep(2);
              }}
              className="fp-btn fp-secondary"
              disabled={loading}
            >
              رجوع
            </button>
          </div>
        </div>
      )}

      {/* Message overlay (user provided) */}
      {showMessage && (
        <div className="overlay">
          <div className="home-owner-message">
            <p>{message}</p>
            <button
              onClick={() => setShowMessage(false)}
              className="fp-close-btn"
            >
              اغلاق
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
